var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.valueCopy,
          expression: "valueCopy",
        },
      ],
      staticClass: "form-control simple-select",
      class: _vm.inputClasses,
      attrs: {
        "data-toggle": "tooltip-city",
        id: _vm.id,
        name: _vm.name,
        title: _vm.title,
        disabled: _vm.disabled,
        required: _vm.required,
        multiple: _vm.multiple,
      },
      on: {
        focus: function ($event) {
          return _vm.handleFocus(true)
        },
        blur: function ($event) {
          return _vm.handleFocus(false)
        },
        input: _vm.handleModelInput,
        change: function ($event) {
          var $$selectedVal = Array.prototype.filter
            .call($event.target.options, function (o) {
              return o.selected
            })
            .map(function (o) {
              var val = "_value" in o ? o._value : o.value
              return val
            })
          _vm.valueCopy = $event.target.multiple
            ? $$selectedVal
            : $$selectedVal[0]
        },
      },
    },
    _vm._l(_vm.optionsList, function (option, index) {
      return _c(
        "option",
        {
          key: `${_vm.id}-${index}`,
          domProps: { value: _vm.reduceItem(option) },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.label in option ? option[_vm.label] : option) +
              "\n    "
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }